import http from '@/plugins/http'
const adminApi = process.env.VUE_APP_ADMIN_API;
//登录 获取手机验证码
export const loginGetMobileCode = (params={}) => {
    const url = adminApi  + 'common/sendSms'
    params.op_type='login'
    return http.fetchPost(url, params);
}
//手机号登录
export const loginMobile = (params={}) => {
    const url = adminApi  + 'report/loginByPhone'
    return http.fetchPost(url, params);
}
export const logoutApi = (params={}) => {
    const url = adminApi  + 'report/logout'
    return http.fetchPost(url, params);
}
export const invitationGetMobileCode = (params={}) => {
    const url = adminApi  + 'common/sendInvitationCode'
    return http.fetchPost(url, params);
}
export const memberExitTeam = (params={}) => {
    const url = adminApi  + 'report/user/exitTeam'
    return http.fetchPost(url, params);
}

export const updateUserInfo = (params={}) => {
    const url = adminApi  + 'report/user/updateUserInfo'
    return http.fetchPost(url, params);
}

export const getMsgList = (params={}) => {
    const url = adminApi  + 'common/user/getMsgList'
    return http.fetchPost(url, params);
}
export const readMsg = (params={}) => {
    const url = adminApi  + 'report/user/readMsg'
    return http.fetchPost(url, params);
}
//邮箱登录
export const loginEmail = (params={}) => {
    const url = adminApi  + 'report/loginByEmail'
    return http.fetchPost(url, params);
}

//微信登录
export const loginByWechat = (params={}) => {
    const url = adminApi  + 'report/loginByWechat'
    return http.fetchPost(url, params);
}
//微信绑定
export const bindWechat = (params={}) => {
    const url = adminApi  + 'report/user/bindWechat'
    return http.fetchPost(url, params);
}
// 密码登录
// export const loginAccount = (params={}) => {
//     const url = adminApi  + 'login/pwd'
//     return http.fetchPost(url, params);
// }
// 邮箱验证
// export const loginEmail = (params={}) => {
//     const url = process.env.VUE_APP_LOGIN_API  + 'password/sendRestLink'
//     return http.fetchPost(url, params);
// }

//忘记密码
export const forgetPwd = (params={}) => {
    const url = adminApi  + 'common/forgetPwd'
    return http.fetchPost(url, params);
}
//重置密码
export const resetPwd = (params={}) => {
    const url = adminApi  + 'common/resetPwd'
    return http.fetchPost(url, params);
}
//修改密码
export const modifyPwd = (params={}) => {
    const url = adminApi  + 'report/user/modifyPwd'
    return http.fetchPost(url, params);
}

